import { useOrchestrator } from '../core/context';
export function useOrchestratorParams() {
  const {
    currentParams
  } = useOrchestrator();
  return currentParams;
}
//# sourceMappingURL=useOrchestratorParams.js.map